import React from 'react';
import {Form, FormGroup, Label, Input, FormText,Badge,Button } from 'reactstrap';
import {resetPasswordChange} from '../functions/resetPassword';
import {NavLink} from 'react-router-dom';

const required = (val) => val && val.length;
const validEmail = (val) => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i.test(val);

class ResetPassword extends React.Component{
    constructor(props){
        super(props);
        this.state={
            // store form data
            password:"",
            confirmPassword:"",
            checkBox:false,
            email:"",

            // display error
            errorPassword:"",
            errorConfirmPassword:"",
            errorServer:"",

            // Manage visibility
            divSuccess:"none",
            divInputPassword:"",
            buttonName:"Submit",

            // get Token
            token:""
        }
    }

    componentDidMount=()=>{
        // console.log(this.props.match.params.token);
        this.setState({
            token:this.props.match.params.token
        });
    }

    myChangeHandler = (event) => {
        let nam = event.target.name;
        let val = event.target.value;
        this.setState({[nam]: val});
    }

    handleCheckBox = (event) =>{
        this.setState({
            checkBox:!this.state.checkBox
        })
    }

    validate = (event)=>{
        let nam = event.target.name;
        let val = event.target.value;
        console.log(nam)
        if(nam==="email" && !validEmail(val)){
            this.setState({errorEmail: "Invalid Email"});
        }
        else if(nam==="email" && validEmail(val)){
            this.setState({errorEmail:""});
        }
        if(nam==="password" && !required(val)){
            this.setState({errorPassword: "Password Cannot be empty"});
        }
        else if(nam==="email" && required(val)){
            this.setState({errorPassword:""});
        }
        if(nam==="confirmPassword" && this.state.password!==val){
            this.setState({errorConfirmPassword: "Password donot Match"});
        }
        else if(nam==="confirmPassword" && this.state.password===val){
            this.setState({errorConfirmPassword: ""});
        }
    }

    mySubmitHandler = (event)=>{
        event.preventDefault();
        if(required(this.state.password) && this.state.password===this.state.confirmPassword && validEmail(this.state.email)){
            this.setState({
                buttonName:"Sending..",
                errorPassword:"",
                errorEmail:"",
                errorConfirmPassword:"",
                errorServer:""
            });
            resetPasswordChange(this.state.email.toLowerCase(),this.state.password,this.state.token)
            .then((resp)=>{
                console.log(resp);
                if(resp){
                    if(resp.success){
                        this.setState({
                            divSuccess:"",
                            divInputPassword:"none"
                        });
                        setTimeout(()=>{
                            this.props.history.push('/login');
                        },3000);
                    }
                    else{
                        this.setState({
                            buttonName:"Submit",
                            errorServer:resp.message
                        })
                    }
                }
                else{
                    this.setState({
                        buttonName:"Submit",
                        errorServer:"Try Again. Cannot Reach Server."
                    })
                }
            })
        }
        else{
            if(!validEmail(this.state.email)){
                this.setState({errorEmail: "Invalid Email"});
            }
            else if(validEmail(this.state.email)){
                this.setState({errorEmail:""});
            }
            if(!required(this.state.password)){
                this.setState({errorPassword: "Password Cannot be empty"});
            }
            else if(required(this.state.password)){
                this.setState({errorPassword:""});
            }
            if(this.state.password!==this.state.password){
                this.setState({errorConfirmPassword: "Password donot Match"});
            }
            else if(this.state.password===this.state.password){
                this.setState({errorConfirmPassword: ""});
            }
        }
    }

    render(){
        return(
            <div className="container">
                <div className="row justify-content-center login" style={{display:this.state.divInputPassword}}>
                    <Form  onSubmit={this.mySubmitHandler}>
                        <FormGroup>
                            <Label for="email">Enter Email</Label>
                            <Input
                                className="col"
                                id="email"
                                type='text'
                                name='email'
                                onChange={this.myChangeHandler}
                                value={this.state.email}
                                onBlur={this.validate}
                            />
                            <FormText color="danger">{this.state.errorEmail}</FormText>
                        </FormGroup>

                        <FormGroup>
                            <Label for="email">Enter New Password</Label>
                            <Input
                                className="col"
                                id="password"
                                type={this.state.checkBox?"text":"password"}
                                name='password'
                                onChange={this.myChangeHandler}
                                value={this.state.password}
                                onBlur={this.validate}
                            />
                            <FormText color="danger">{this.state.errorPassword}</FormText>
                        </FormGroup>
                        <FormGroup>
                            <Label for="email">Confirm Password</Label>
                            <Input
                                className="col"
                                id="confirmPassword"
                                type={this.state.checkBox?"text":"password"}
                                name='confirmPassword'
                                onChange={this.myChangeHandler}
                                value={this.state.confirmPassword}
                                onBlur={this.validate}
                            />
                            <FormText color="danger">{this.state.errorConfirmPassword}</FormText>
                        </FormGroup>
                        <input 
                            type="checkbox" 
                            checked={this.state.checkBox} 
                            onChange={this.handleCheckBox}
                            />
                        <label>Show Password</label>
                        <br/>
                        <input type="submit" value={this.state.buttonName}/>
                        <FormText color="danger">{this.state.errorServer==="Failed to fetch"?"Server is down. Please try again":""}</FormText>
                        <FormText color="danger">{this.state.errorServer}</FormText>
                    </Form>
                </div>
                <div  className="mt-3" style={{display:this.state.divSuccess}}>
                    <h4><Badge color="success">Password Successfully Changed for email {this.state.email}</Badge></h4>
                    <h5>Redirecting to login page in 3 seconds. Or Click <NavLink to="/login">Here</NavLink></h5>
                </div>
                {/* <div  className="mt-3">
                    <h5><Badge color="success">{this.state.errorServer}</Badge></h5>
                </div> */}
            </div>
        )
    }
}

export default ResetPassword;